<div class="button" [matTooltip]="tooltip" [ngClass]="{ 'show-hover-child': onHover, 'dark-theme': darkTheme }">
  <mat-icon class="mr-2">edit</mat-icon>
  <span class="d-none d-md-block" *ngIf="showLabel">{{ 'home.edit' | transloco }}</span>
</div>
